"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdentityCheckType = void 0;
var IdentityCheckType;
(function (IdentityCheckType) {
    IdentityCheckType["persona"] = "persona";
})(IdentityCheckType || (exports.IdentityCheckType = IdentityCheckType = {}));
